import { parseStringIntoFormattedStringTime } from './parsers/dateTime/parseStringIntoFormattedStringTime';

export const getTimeDuration = (timeFrom: string, timeTo: string) =>
    `${parseStringIntoFormattedStringTime(timeFrom)}-${parseStringIntoFormattedStringTime(timeTo)}`;
